module.exports = __webpack_public_path__ + "img/add.9a8e3280.svg";